import { constants } from '../config';

export default function setCookiesReducer(state = {}, action) {
  switch (action.type) {
    case constants.GET_COOKIES:
      return { ...state, loading: true, done: false, errorRequest: false };
    case constants.GET_COOKIES_SUCCESS: {
      return { ...state, loading: false, data: action.payload, done: true };
    }
    case constants.GET_COOKIES_FAIL:
      return { ...state, loading: false, errorRequest: true };

    default:
      return state;
  }
}
